module.exports = __webpack_public_path__ + "img/low hips.bcb986bd.png";